import React from "react";

import MobileTitleManPowerData from "./TitleManPowerData";

function MobileManPower({ Data, getData, projectList, projectId ,itemsCategory,Type}) {
  

  return (
    <div className=" w-full  h-[70vh] overflow-y-auto">
      {Data &&
        Data.map((item, idx) => {
          return (
            <MobileTitleManPowerData rowData={item} key={idx} getData={getData} projectList={projectList} projectId={projectId} itemsCategory={itemsCategory} Type={Type} />
          );
        })}
    </div>
  );
}

export default MobileManPower;
